import { toast } from 'react-toastify'

export const Actions = {
  INSERT: 'insert',
  PLAY: 'play',
  PLAYBETWEEN: 'playbetween',
  PAUSE: 'pause',
  SETFRAGMENT: 'setfragment',
  STEPBACK: 'stepback',
  STEPFORWARD: 'stepforward',
  MARKIN: 'markin',
  MARKOUT: 'markout',
  GETPOSITION: 'getposition',
  GOTOMARKIN: 'gotomarkin',
  GOTOMARKOUT: 'gotomarkout',
}

export const PlayerService = (command, selected, position) => {
  switch (command) {
    case Actions.INSERT:
      return `insert:${selected.pendente.midia.filepath_normalized}#${selected.pendente.duracao}`
    case Actions.GETPOSITION:
      return 'getposition'
    case Actions.SETFRAGMENT:
      return `setfragment:${position}`
    case Actions.GOTOMARKIN:
      return `setfragment:${position}`
    case Actions.MARKIN:
      return 'markin'
    case Actions.STEPBACK:
      return 'stepback'
    case Actions.PLAY:
      return 'play'
    case Actions.PLAYBETWEEN:
      return 'playbetween'
    case Actions.PAUSE:
      return 'pause'
    case Actions.STEPFORWARD:
      return 'stepforward'
    case Actions.MARKOUT:
      return 'markout'
    case Actions.GOTOMARKOUT:
      return `setfragment:${position}`
    default:
      return toast.error(`Comando Inválido recebido: ${command}`)
  }
}
